// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "eh_on_fileLoad", inline: true };
const loggerMsgs = {
  eventStart: (EVENTDATA) => ["file has been loaded", EVENTDATA],
  skipInsert: ["file insertion skipped"],
  imgElNotFound: (FILEID) => [`no img elements found with matching data-file-id ${FILEID}`],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function eh_on_fileLoad(EVENTDATA) {
  // Setup...
  const { rawResult, item } = EVENTDATA;
  const { uuid, type } = item;
  const { loadQueueConfig } = this.state;
  const { skipFileInsertion, storeLoadedItems } = loadQueueConfig;
  this.logger("event", loggerMsgs.eventStart(EVENTDATA), "event", { ...logArgs, inline: false });

  ///////////////////////////
  // Loaded file insertion //
  ///////////////////////////

  // Create object URL for loaded file...
  const objectURL = URL.createObjectURL(rawResult);

  // If applicable, store loaded item...
  if (storeLoadedItems) this.setState({ loadedItems: [...this.state.loadedItems, { ...item, objectURL }] });

  // Guard...
  if (skipFileInsertion) return this.logger("warning", loggerMsgs.skipInsert, "warning", logArgs);

  // Insert loaded file...
  this.api.insert_loadedAsset({ uuid, type, objectURL });
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
